import service from "@/store/services/establishment-internal-invoices-service";

export const state = () => ({
  list: {},
  transfer: {},
  meta: {},
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, transfer) => {
    state.transfer = transfer;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
};

export const actions = {
  list({ commit }, params = {}) {
    return service.list(params).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },
  get({ commit }, params) {
    return service.get(params).then((transfer) => {
      commit("SET_RESOURCE", transfer);
    });
  },
  add({ commit }, params) {
    return service.add(params).then((transfer) => {
      commit("SET_RESOURCE", transfer);
    });
  },
  update({ commit }, params) {
    return service.update(params).then((transfer) => {
      commit("SET_RESOURCE", transfer);
    });
  },
  destroy(_ctx, params) {
    return service.destroy(params);
  },
  validate({ commit }, params) {
    return service.validate(params).then((transfer) => {
      commit("SET_RESOURCE", transfer);
    });
  },
  accept({ commit }, params) {
    return service.accept(params).then((transfer) => {
      commit("SET_RESOURCE", transfer);
    });
  },
  reject({ commit }, params) {
    return service.reject(params).then((transfer) => {
      commit("SET_RESOURCE", transfer);
    });
  },
  cancel({ commit }, params) {
    return service.cancel(params).then((transfer) => {
      commit("SET_RESOURCE", transfer);
    });
  },
  print(_ctx, params) {
    return service.print(params);
  },
  revertToDraft({ commit }, params) {
    return service.revertToDraft(params).then((transfer) => {
      commit("SET_RESOURCE", transfer);
    });
  },
};

export const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.page?.total,
  transfer: (state) => state.transfer,
};

const module = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default module;
